export function getView(person) {
  if (person.is_employee) return 'Employee'
  if (person.is_external_professional) return 'ExternalProfessional'
  return 'No'
}
